module.exports = __webpack_public_path__ + "img/home-index-menu1.ff736b0f.png";